import React, { useState, useEffect , useMemo , useRef} from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { MenuItem,
    TextField,
    Tooltip,
    Popover
} from '@material-ui/core';

import { useTable } from "react-table";

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import DateFnsUtils from '@date-io/date-fns';
import esLocale from 'date-fns/locale/es'

import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { convertDateToJulian } from '../../constants/component/convertDateToJulian';
import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";

import FiltersService from "../../services/filters.service";
import DetailPreviousProgramService from '../../services/detail-previous-program.service';

import '../../styles/style.scss';
import usersService from '../../services/users.service';


export const DetailPreviousProgramScreen = () => {

    const dateMin = new Date();

    const [selectStartDate, handleStartDateChange] = useState( null );
    const [selectEndDate, handleEndDateChange] = useState( null );

    const { isLoggedIn, user } = useSelector( state => state.auth); 
    const an8Logged = isLoggedIn? user.noCustomer:'---';

    const dispatch = useDispatch();
    const history = useHistory();

    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();
  
    const [customers, setCustomers] = useState({
      isLoading: true,
      isDisabled: true,
      data:[]
    });
    const [contentCompany, setContentCompany] = useState({
      isLoading: false,
      isDisabled: true,
      data:['']
    });
  
    const [contentCement, setContentCement] = useState({
      isLoading: false,
      isDisabled: true,
      data:['']
    });
  
    const [contentRetirement, setContentRetirement] = useState({
      isLoading: false,
      isDisabled: true,
      data:['']
    });

    const [detailPreviousProgramFilters, setDetailPreviousProgramFilters] = useState([]);
    const [detailPreviousProgram, setDetailPreviousProgram] = useState([]);
    const detailPreviousProgramRef = useRef();
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [isSubmitingData, setIsSubmitingData] = useState(false);
    const [isDownloadFile, setIsDownloadFile] = useState(false);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
  
    const [errorResponse, setErrorResponse] = useState('');
    const [isErrorResponse, setIsErrorResponse] = useState(false);
  
    detailPreviousProgramRef.current = detailPreviousProgram;

    const validationSchema = Yup.object().shape({
      an8: Yup.string().required('valor requerido').nullable(),
      startDate: Yup.date().default(selectStartDate).required('valor requerido').nullable(),
      endDate: Yup.date().default(selectEndDate).required('valor requerido').nullable()
      .min(selectStartDate? selectStartDate: dateMin)
    });
 
    const {
        register,
        control,
        handleSubmit,
        getValues
    } = useForm({
      resolver: yupResolver(validationSchema),
    });

    useEffect(() => {
      getCustomers();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => {
      let dateSubtract = new Date();
      dateSubtract.setMonth(dateSubtract.getMonth()-6);
  
      const dateMinDefaultOrder = dateSubtract;
      const dateMaxDefaultOrder = new Date();

      handleStartDateChange(dateMinDefaultOrder);
      handleEndDateChange(dateMaxDefaultOrder);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    /**
   * Recupera la lista de clientes
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Noviembre 2023
   */
  const getCustomers = () =>{

    setCustomers({
      isLoading: true,
      isDisabled: true,
      data:[]
    })
    usersService.getCustomerAssociatesByAN8(an8Logged).then((response)=>{
      let customersResponse = response;
        
      setCustomers({
        isLoading: false,
        isDisabled: false,
        data:customersResponse
      });
    }).catch((error)=>{
      console.log(error);
      setCustomers({
        isLoading: false,
        isDisabled: false,
        data:['']
      });
      
      if(sessionDifference > Number(tokenExpired)){
        sesionExpired(dispatch, history);
      } else{
        actionErrorConnection(error, 'Error al recuperar clientes.');
      }
    });
  }

  /** 
     * Recupera el an8 seleccionado
     * @author alSanchez - ETE
     * @version 1.0.0 - Noviembre 2023
     * 
    */
  const onCustomerChange = () =>{
    const params = getValues();
    console.log(params.an8 && params.an8 !== '')
    params.an8 && params.an8 !== '' ? getFilters(params.an8) : null;
  }

  /** 
   * Recupera los filtros del sistema por an8 empezando por la planta
   * @author alSanchez - ETE
   * @param {string} an8Customer - identificador del cliente seleccionado
   * @version 1.0.0 - Noviembre 2023
   * 
  */

    const getFilters = (an8Customer) =>{
      getCompany(an8Customer);
      getCement(an8Customer);
      getRetirement(an8Customer);
    }

    /** 
     * Recupera lista de plantas filtrado por an8
     * @author alSanchez - ETE
     * @param {string} an8Customer - identificador del cliente seleccionado
     * @version 1.0.0 - Noviembre 2023
     * 
    */
    const getCompany = (an8Customer) =>{
      setContentCompany({
        isLoading: true,
        isDisabled: true,
        data:[]
      })
      FiltersService.getCompany(an8Customer).then((response)=>{
        setContentCompany({
          isLoading: false,
          isDisabled: false,
          data: response
        });
        getCement(an8Customer)
      }).catch((error)=>{
        setContentCompany({
          isLoading: false,
          isDisabled: false,
          data:['']
        });
        setErrorResponse('Error al recuperar lista de plantas');
        actionErrorConnection(error);
      });
    }

    /** 
     * Recupera lista de cemento
     * @author alSanchez - ETE
     * @param {string} an8Customer - identificador del cliente seleccionado
     * @version 1.0.0 - Noviembre 2023
     * 
    */
    const getCement = (an8Customer) =>{
      setContentCement({
        isLoading: true,
        isDisabled: true,
        data:[]
      })
      FiltersService.getCement(an8Customer).then((response)=>{
        setContentCement({
          isLoading: false,
          isDisabled: false,
          data: response
        });
        getRetirement(an8Customer);
      }).catch((error)=>{
        setContentCement({
          isLoading: false,
          isDisabled: false,
          data:['']
        });
        setErrorResponse('Error al recuperar lista de tipo cemento');
        actionErrorConnection(error);
      });
    }

    /** 
     * Recupera lista de forma de retiro
     * @author alSanchez - ETE
     * @param {string} an8Customer - identificador del cliente seleccionado
     * @version 1.0.0 - Noviembre 2023
     * 
    */

    const getRetirement = (an8Customer) =>{
      setContentRetirement({
        isLoading: true,
        isDisabled: true,
        data:[]
      });
      FiltersService.getRetirement(an8Customer).then((response)=>{
        setContentRetirement({
          isLoading: false,
          isDisabled: false,
          data: response
        });
      }).catch((error)=>{
        setContentRetirement({
          isLoading: false,
          isDisabled: false,
          data:['']
        });
        setErrorResponse('Error al recuperar lista de forma de retiro');
        actionErrorConnection(error);
      });
    }
      
    /**
     * Realiza la solicitud para recuperar datos de pago por filtros
     * @param {*} data - información del formulario
     * @param {date} maxDate - fecha maxima reduperada
     * @param {date} minDate  - fecha minima recuperada
     * @param {boolean} pagination - valida si fue solicitado un cambio de pagina
     * @param {boolean} pageSizeChange - valida si fue realizada una solicitud de cambio de tamaño en tabla
     * @param {string} pageChange - cantidad de datos a obtener en la tabla
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const onSubmit = (data, maxDate, minDate) => {

      const element = document.getElementById('collapseExample');
      element.classList.remove('show');

      setDetailPreviousProgram([]);
      setIsLoadingData(true);
      setIsErrorResponse(false);
      setIsSubmitingData(true);

      const params = getValues();

      if(!data) {
        params.startDate = convertDateToJulian(minDate);
        params.endDate = convertDateToJulian(maxDate);
      } else {
        params.startDate = convertDateToJulian(data.startDate);
        params.endDate = convertDateToJulian(data.endDate);
      }

      setDetailPreviousProgramFilters(params);


      const dataFilter = params;

      getDetailPreviousProgramService(dataFilter);

    };

    /**
     * Realiza la petición al servicio de recuperación de detalle del programa
     * @param {*} dataFilter - información de filtros
     */
    const getDetailPreviousProgramService = (dataFilter) =>{
      DetailPreviousProgramService.getAlldetailPreviousProgramByFilters(dataFilter)
      .then((response) => {
        setIsErrorResponse(false);
        setIsLoadingData(false);
        setDetailPreviousProgram(response.orderSale);
      })
      .catch((error) => {
        setIsLoadingData(false);
        console.log(error);
        if(error.response){
          setErrorResponse(error.response.data.mensaje);
          if(sessionDifference > Number(tokenExpired)){
            sesionExpired(dispatch, history);
          }
        } else{
          setErrorResponse(error);
          actionErrorConnection(error);
        }
        setIsErrorResponse(true);
      });
    };

    /**
     * Realiza cambio para mostrar el selector de archivo de descarga
     * @param {*} event - Recupera el cambio del boton pulsado 
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    /**
     * Cierra las opciones de descarga al seleccionar un archivo a descargar
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const handleClose = () => {
      setAnchorEl(null);
    };

    /**
     * Realiza la descarga del archivo
     * @param {*} e - indormación del boton pulsado
     * @param {string} typeFile - diferenciador de archivo a descargar
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const downloadFile = (e, typeFile) =>{

      handleClose();

      setIsDownloadFile(true);

      const startDateName = detailPreviousProgramFilters.startDate ?
                           detailPreviousProgramFilters.startDate : '';
      
      const endDateName = detailPreviousProgramFilters.endDate ?
                        detailPreviousProgramFilters.endDate : '';

      const companyName = detailPreviousProgramFilters.company ? `_${detailPreviousProgramFilters.company.trim()}` : '';
      const cementName = detailPreviousProgramFilters.cement ? `_${detailPreviousProgramFilters.cement.trim()}` : '';
      const retirementName = detailPreviousProgramFilters.retirement ? `_${detailPreviousProgramFilters.retirement.trim()}` : '';
              
      const fileName = 'detalle_programa_'+ startDateName +'-'+ endDateName + companyName + cementName + retirementName;

      if(typeFile === 'Pdf'){
        getDownloadPdf(fileName);
      } else if (typeFile === 'Xlsx'){
        getDownloadXls(fileName);
      }
    };

    const getDownloadPdf = (fileName) => {
      DetailPreviousProgramService.downloadDetailPreviousProgramFdf(detailPreviousProgramFilters, getValues().an8).then(
        (response)=>{

          const byteString = window.atob(response.split(',')[1]);
          const mimeString = response.split(',')[0].split(':')[1].split(';')[0];

          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i)
          }

          const dataBlob = new Blob([ab], { type: mimeString });

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataBlob, `${fileName}.pdf`);
            setIsDownloadFile(false);
            return
          }
      
          const url = window.URL.createObjectURL(dataBlob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${fileName}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();

          setIsDownloadFile(false);
        },
        (error)=>{
          setIsDownloadFile(false);
          actionErrorConnection(error, 'Error al descargar archivo PDF.');
        });
      
      console.log('descargar archivo pdf');

    }

    const getDownloadXls = (fileName) => {
      DetailPreviousProgramService.downloadDetailPreviousProgramXlsx(detailPreviousProgramFilters, getValues().an8).then(
        (response)=>{
          console.log('ok descarga');

          const byteString = window.atob(response.split(',')[1]);
          const mimeString = response.split(',')[0].split(':')[1].split(';')[0];

          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i)
          }

          const dataBlob = new Blob([ab], { type: mimeString });

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataBlob, `${fileName}.xls`);
            setIsDownloadFile(false);
            return
          }
      
          const url = window.URL.createObjectURL(dataBlob);
          const link = document.createElement('a');
          link.href = url
          link.setAttribute('download', `${fileName}.xls`);
          document.body.appendChild(link);
          link.click();
          link.remove();

          setIsDownloadFile(false);
        },
        (error)=>{
          setIsDownloadFile(false);
          actionErrorConnection(error, 'Error al descargar archivo xls.');
        });
      console.log('descargar archivo xls');
      
    }
  
    /**
     * Campos de la tabla
     */
    const columns = useMemo(
      () => [
        {
          Header: 'Cliente',
          accessor: 'an8'
        },
        {
          Header: "Fecha",
          accessor: "date",
        },
        {
          Header: "Planta",
          accessor: "plant",
        },
        {
          Header: "Orden de venta",
          accessor: "sale",
        },
        {
          Header: "Tipo de cemento",
          accessor: "cement",
        },
        {
          Header: "Forma de retiro",
          accessor: "retirement",
        },
        {
          Header: "T.N.",
          accessor: "tn",
        },
        {
          Header: "U.M.",
          accessor: "um",
        },
      ],
      []
    );
  
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow
    } = useTable({
      columns,
      data: detailPreviousProgram,
    });

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                <NavTopMenu />


                <div className="container ps-3 pe-3 container-size">
                  <div className="row base-container ">
                    <div className="col-12 border-title text-title pt-2 pb-2 ps-4">
                      <span className="h4">Detalle programa previo</span>
                    </div>
                  
                    <div className="col-12 pt-1 pb-3 ps-2 pe-2">
                    <div className="row ">
                      <div className="col-12 ">
                        <div className="w-100 d-flex justify-content-end">
                          {
                            isDownloadFile ?
                            <Tooltip title="Descargargando..." placement="top-start" arrow>
                              <div className="custom-icon-loading me-1">
                                <i className="fas fa-spinner fa-spin"></i>
                              </div>
                            </Tooltip>
                            :
                            <Tooltip title="Descargar resultados" placement="top-start" arrow>
                              <div>
                                <button 
                                  className="btn custom-btn-icons" 
                                  aria-describedby={id} variant="contained"
                                  onClick={handleClick}
                                  type="button"
                                  disabled={isLoadingData || isErrorResponse || !isSubmitingData}
                                >
                                  <i className="fas fa-download"></i>
                                </button>
                              </div>
                            </Tooltip>
                          }
                          <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'center',
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'center',
                            }}
                          >
                            <div className="pt-1 pb-1 ps-2 pe-2">
                              <div className="mb-1">
                                <span className="text-popover">Seleccionar formato.</span>
                              </div>
                              <div className="mb-2 d-flex justify-content-center">
                                <Tooltip title="Descargar pdf" placement="top-start" arrow>
                                  <button className="btn custom-btn-icons" 
                                  onClick={(e)=>downloadFile(e, 'Pdf')}
                                  type="button">
                                    <i className="fas fa-file-pdf fa-2x" ></i>
                                  </button>
                                </Tooltip>
                                <Tooltip title="Descargar xls" placement="top-start" arrow>
                                  <button className="btn custom-btn-icons" 
                                  onClick={(e)=>downloadFile(e, 'Xlsx')}
                                  type="button">
                                    <i className="fas fa-file-excel fa-2x"></i>
                                  </button>
                                </Tooltip>
                              </div>
                            </div>                  
                          </Popover>
                          {(customers.isLoading || contentCompany.isLoading || contentCement.isLoading || contentRetirement.isLoading) && 
                              <Tooltip title="Cargando filtro..." placement="top-start" arrow>
                                <div className="custom-icon-loading me-1">
                                  <i className="fas fa-spinner fa-spin"></i>
                                </div>
                              </Tooltip>
                            }
                          <Tooltip title="Filtrar" placement="top-start" arrow>
                            <button className="btn custom-btn-icons" 
                            type="button" data-bs-toggle="collapse" 
                            data-bs-target="#collapseExample" aria-expanded="false" 
                            aria-controls="collapseExample">
                              <i className="fas fa-filter"></i>
                            </button>
                          </Tooltip>
                        </div>
                        <div className="collapse show" id="collapseExample">
                          <div className="filter-continer">
                            <div className="container mt-3">
                              <form className="row">
                              <div className="col-md-5 col-lg-4 mb-3">
                                <TextField
                                    select
                                    id="an8"
                                    name="an8"
                                    label="Num. cliente*"
                                    variant="outlined"
                                    size="small" 
                                    disabled={customers.isDisabled || customers.isLoading}
                                    fullWidth
                                    defaultValue={''}
                                    {...register('an8')}
                                    onBlur={onCustomerChange}
                                    >
                                        <MenuItem value="">Seleccionar cliente</MenuItem>
                                    {customers.data.map(({noCustomer, name}) => (
                                        <MenuItem key={noCustomer} value={noCustomer}>
                                        {noCustomer} - {name}
                                        </MenuItem>
                                    ))}
                                  </TextField>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                    <MuiPickersUtilsProvider 
                                        utils={DateFnsUtils} 
                                        locale={esLocale}>
                                        <DatePicker
                                            disableToolbar
                                            autoOk
                                            fullWidth
                                            required
                                            control={control}
                                            id="startDate"
                                            name="startDate"
                                            inputVariant="outlined"
                                            variant="inline"
                                            label="Fecha de inicio"
                                            size="small" 
                                            format="dd/LLLL/yyyy"
                                            value={selectStartDate}
                                            onChange={handleStartDateChange}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                    <MuiPickersUtilsProvider 
                                        utils={DateFnsUtils} 
                                        locale={esLocale}>
                                        <DatePicker
                                            disableToolbar
                                            autoOk
                                            fullWidth
                                            required
                                            control={control}
                                            id="endDate"
                                            name="endDate"
                                            inputVariant="outlined"
                                            variant="inline"
                                            label="Fecha de Fin"
                                            size="small" 
                                            format="dd/LLLL/yyyy"
                                            minDate={selectStartDate}
                                            minDateMessage="La fecha debe ser mayor a la de inicio"
                                            value={selectEndDate}
                                            onChange={handleEndDateChange}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                <TextField
                                    select
                                    id="company"
                                    name="company"
                                    label="Planta"
                                    variant="outlined"
                                    size="small" 
                                    fullWidth
                                    defaultValue={''}
                                    disabled={contentCompany.isDisabled || contentCompany.isLoading}
                                    {...register('company')}
                                    >
                                        <MenuItem value="">Seleccionar planta</MenuItem>
                                    {contentCompany.data.map((optionCompany) => (
                                        <MenuItem key={optionCompany.codigo} value={optionCompany.codigo}>
                                        {optionCompany.nombre}
                                        </MenuItem>
                                    ))}
                                  </TextField>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                <TextField
                                    select
                                    id="cement"
                                    name="cement"
                                    label="Tipo de cemento"
                                    variant="outlined"
                                    size="small" 
                                    fullWidth
                                    defaultValue={''}
                                    disabled={contentCement.isDisabled || contentCement.isLoading}
                                    {...register('cement')}
                                    >
                                        <MenuItem value="">Seleccionar cemento</MenuItem>
                                    {contentCement.data.map((optionCement) => (
                                        <MenuItem key={optionCement} value={optionCement}>
                                        {optionCement}
                                        </MenuItem>
                                    ))}
                                  </TextField>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                <TextField
                                    select
                                    id="retirement"
                                    name="retirement"
                                    label="Forma de retiro"
                                    variant="outlined"
                                    size="small" 
                                    fullWidth
                                    defaultValue={''}
                                    disabled={contentRetirement.isDisabled || contentRetirement.isLoading}
                                    {...register('retirement')}
                                    >
                                        <MenuItem value="">Seleccionar forma</MenuItem>
                                    {contentRetirement.data.map((option, idContent) => (
                                        <MenuItem key={idContent} value={option.codigo}>
                                        {option.nombre}
                                        </MenuItem>
                                    ))}
                                  </TextField>
                                </div>
                                <div className="col-12 w-100 d-flex justify-content-end">
                                  <Tooltip title={(!selectStartDate || !selectEndDate || !getValues().an8 || getValues().an8 === '' )? "Completar filtros obligatorios":"Buscar"} placement="top-start" arrow>
                                    <div>
                                      <button 
                                      className="ms-2 mb-3 btn custom-btn"
                                      disabled={isLoadingData|| !selectStartDate || !selectEndDate || !getValues().an8 || getValues().an8 === ''}
                                      onClick={handleSubmit(onSubmit)}
                                      type='submit'
                                      data-bs-toggle="collapse" 
                                      data-bs-target="#collapseExample" 
                                      aria-expanded="false" 
                                      aria-controls="collapseExample"
                                      >
                                        <i className="fas fa-search"></i>
                                      </button>
                                    </div>
                                  </Tooltip>
                                </div>
                            </form>
                            </div>
                          
                          </div>
                        </div>
                            
                            
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <table
                            className=""
                            {...getTableProps()}
                          >
                            <thead>
                              {headerGroups.map((headerGroup, i) => (
                                <tr {...headerGroup.getHeaderGroupProps()} className="border-content " key={i}>
                                  {headerGroup.headers.map((column, j) => (
                                    <th {...column.getHeaderProps()}
                                    className="border-element header-element header-text pt-3 pb-3" key={j}>
                                      {column.render("Header")}
                                    </th>
                                  ))}
                                </tr>
                              ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                              {rows.map((row) => {
                                prepareRow(row);
                                return (
                                  <React.Fragment key={row.getRowProps().key}>
                                    <tr className="element-row border-content">
                                      {row.cells.map((cell,index) => {
                                        return (
                                          <td className="border-element content-text padding-row"
                                          {...cell.getCellProps()} key={index}>
                                            {
                                              cell.column.id === 'an8' ? 
                                              getValues().an8
                                              : cell.render("Cell")
                                            }
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  </React.Fragment>
                                );
                              })}
                            </tbody>
                          </table>
                          {(isErrorResponse) &&
                            <div className="error-message border-content pt-4 pb-4">
                              <span className="">Error: {errorResponse && errorResponse.toString()}</span>
                            </div>}
                          {(isLoadingData) &&
                            <div className="border-content pt-4 pb-4 custom-icon-loading">
                              <i className="fas fa-spinner fa-spin"></i>
                            </div>}
                            {(detailPreviousProgram.length === 0 && !isLoadingData && !isErrorResponse && isSubmitingData) &&
                            <div className="element-row-message border-content pt-4 pb-4 ">
                              <span>Los filtros seleccionanos no devolvieron coincidencias.</span>
                            </div>}
                            {
                              (!isSubmitingData && !isLoadingData && !isErrorResponse) &&
                              <div className="element-row-message border-content pt-4 pb-4">
                                <span>Ejecute una búsqueda para obtener resultados.</span>
                              </div>
                            }
                        </div>
                      </div>

                    </div>
                      

                  </div>
                </div>

                </div>
            </div>
          </div>
        
           
            <Footer/>
        </>
    )
}
